export const CUSTOMER_COUPON_PERMISSION = {
  VIEW: 'CUSTOMER_VOUCHER_VIEW',
  EDIT: 'CUSTOMER_VOUCHER_EDIT',
};
